import { Button, Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import DropDownMultiSelect from '../../../../../components/DropDownMultiSelect/index';
import { useGetQsetDropdownDetailsMutation } from '../../../../../features/authentication/qSetApiSlice';
import { useOutletContext } from 'react-router';

const MyContent = () => {
  const [getQsetDetails] = useGetQsetDropdownDetailsMutation();
  const outletContext = useOutletContext();
  const [hasMore, setHasMore] = useState(true);
  const [initial, setInitial] = useState(true);
  const [qsetData, setQsetData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const takeSize = 30;

  useEffect(() => {
    getQsetDataAsync(0, false, '');
  }, []);

  const getQsetDataAsync = async (skip, isSearch, searchString) => {
    let newSets = [];
    if (initial || isSearch) {
      const obj = {
        id: -1,
        name: 'All Question set'
      };
      newSets.push(obj);
    }
    setIsLoading(true);
    const options =
    {
      skip: skip,
      take: takeSize,
      searchString: searchString
    };
    const response = await getQsetDetails(options).unwrap();
    setHasMore((skip + takeSize) < response.total);
    if(isSearch){
      newSets = [...newSets, ...response.data];
    }
    else{
      newSets = [...newSets, ...qsetData, ...response.data];
    }
    if (selectedIds.includes(-1)) {
      const selectedIds = qsetData.map(item => item.id);
      const newIds = response.data.map(item => item.id);
      const updatedIds = [...selectedIds, ...newIds];
      setSelectedIds(updatedIds);
    }
    setQsetData(newSets);
    setInitial(false);
    setIsLoading(false);
  };

  const SearchQuestions = () => {
    var searchRequest = {
      pageNumber: 1,
      pageSize: 25,
      courseIds: [],
      levels: [],
      qsetIds:selectedIds
    };
    outletContext.intializeTeacherSearch(searchRequest);
  };

  const handleChange = (event) => {
    const selectedId = parseInt(event.key);
    if (!selectedIds.includes(selectedId)) {
      if (selectedId == -1) {
        const allQsetIds = qsetData.map(item => item.id);
        setSelectedIds(allQsetIds);
      }
      else {
        setSelectedIds((prevData) => {
          return [...prevData, selectedId];
        });
      }
    }
    else {
      if (selectedId == -1) {
        setSelectedIds([]);
      }
      else {
        const updatedIds = selectedIds.filter(id => id != selectedId);
        setSelectedIds(updatedIds);
      }
    }
  };

  return (
    <Row className='row align-items-center castleQuestionsSearchBox mb-5'>
      <Col>
        {qsetData.length > 0 &&
          <DropDownMultiSelect
            value={qsetData}
            isLoading={isLoading}
            dropdownId='myContetList'
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            onChange={handleChange}
            fetch={getQsetDataAsync}
            hasMore={hasMore}
            takeSize={takeSize}
            placeHolder={selectedIds.length == 0 ? 'My Question Set' : selectedIds.includes(-1) ? 'All selected' : `${selectedIds.length} items selected`}
            isPaginated={true}
          />
        }
      </Col>
      <Col className=''>
        <Button variant='castleWhite btn-width' disabled={selectedIds.length == 0} onClick={() => SearchQuestions()}>Search</Button>
      </Col>
    </Row>
  );
};

export default MyContent;
